module.exports = __webpack_public_path__ + "static/media/load_B.5b350500.gif";